module.exports = __webpack_public_path__ + "media/video_compressed_muted.9c1aff0f.webm";